import React from 'react';
import styled from 'styled-components';
import SelectorScaleRadio from './SelectorScaleRadio';
const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export const SelectorScale = ({
  options,
  name,
  value,
  disabled = false,
  onChange,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, props, options.map(({
    label,
    value: optionValue
  }, index) => {
    return /*#__PURE__*/React.createElement(SelectorScaleRadio, {
      name,
      label,
      disabled,
      onChange,
      key: `${label}-${optionValue}`,
      index: index,
      value: optionValue,
      checked: optionValue === value
    });
  }));
};
export default SelectorScale;
//# sourceMappingURL=index.js.map